import { motion } from 'framer-motion';
import { useState } from 'react';

const PolicyFAQ = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqData = [
    {
      question: "1039是否可以长期使用？",
      answer: "是的。市场采购贸易1039是国家正式批准的贸易方式，自2014年试点以来已运行十年，政策稳定。只要符合规定条件，企业可以长期使用此方式进行合规出口。",
      icon: "ri-time-line",
      color: "text-blue-600"
    },
    {
      question: "1039是否可以变相退税？",
      answer: "不可以。1039模式是免征增值税，不是退税。这是两个完全不同的税收政策。免征是指在出口环节不征收增值税，而退税是先征税后退税。企业不能将1039当作变相退税工具使用。",
      icon: "ri-money-dollar-circle-line",
      color: "text-red-600"
    },
    {
      question: "个体工商户是否可以代收外汇？",
      answer: "个体工商户本身不能直接收汇，但可以通过1039模式下的代收外汇服务来解决收汇问题。这需要通过合规的代收外汇主体来操作，确保符合外汇管理规定。",
      icon: "ri-exchange-dollar-line",
      color: "text-green-600"
    },
    {
      question: "物流与监管仓不配合怎么办？",
      answer: "1039模式要求使用指定的物流服务商和监管仓库，这是政策规定。如遇到不配合的情况，可以：1）选择其他合规服务商；2）向市场管理方投诉；3）联系海关监管部门。白云天健提供配套的物流监管服务。",
      icon: "ri-truck-line",
      color: "text-purple-600"
    },
    {
      question: "1039有哪些商品限制？",
      answer: "1039主要适用于日用消费品，禁止出口国家禁限类商品。具体包括：禁止危险品、管制物品；限制需要特殊资质的商品；鼓励服装、小商品、工艺品等。建议在申报前核实商品是否在允许清单内。",
      icon: "ri-forbid-line",
      color: "text-orange-600"
    },
    {
      question: "单票15万美元如何计算？",
      answer: "15万美元限制是指每一票报关单的总金额不能超过15万美元。这不是累计限制，也不是单个商品限制。如果一票报关单包含多种商品，所有商品货值总和不能超过15万美元。",
      icon: "ri-calculator-line",
      color: "text-teal-600"
    },
    {
      question: "如何确保1039操作合规？",
      answer: "确保合规需要：1）选择正规的市场采购贸易试点；2）通过合规服务商操作；3）真实申报商品信息；4）保留完整业务资料；5）配合海关监管要求。白云天健提供全程合规指导服务。",
      icon: "ri-shield-check-line",
      color: "text-indigo-600"
    }
  ];

  const handleFAQClick = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-[1440px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-primary mb-4">高频误区与监管关注点</h2>
          <p className="text-gray-600 text-lg">提前了解风险点，建立专业可信认知</p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300"
              >
                <button
                  onClick={() => handleFAQClick(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      openFAQ === index ? 'bg-accent/20' : 'bg-gray-100'
                    }`}>
                      <i className={`${faq.icon} text-lg ${
                        openFAQ === index ? 'text-accent' : faq.color
                      }`}></i>
                    </div>
                    <h3 className={`font-semibold transition-colors ${
                      openFAQ === index ? 'text-accent' : 'text-primary'
                    }`}>
                      {faq.question}
                    </h3>
                  </div>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 ${
                    openFAQ === index ? 'bg-accent text-white' : 'bg-gray-100 text-gray-500'
                  }`}>
                    <i className={`ri-arrow-down-s-line transition-transform duration-200 ${
                      openFAQ === index ? 'rotate-180' : ''
                    }`}></i>
                  </div>
                </button>

                {openFAQ === index && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="border-t border-gray-100"
                  >
                    <div className="px-6 py-5 bg-gray-50/50">
                      <div className="flex gap-4">
                        <div className="w-1 bg-accent rounded-full flex-shrink-0"></div>
                        <div className="text-gray-700 leading-relaxed">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        {/* 专业提示 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-12 bg-gradient-to-r from-primary/5 to-accent/5 rounded-xl p-8 border border-primary/10"
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-user-star-line text-accent text-xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-primary mb-3">专业合规建议</h3>
              <div className="text-gray-700 leading-relaxed space-y-2">
                <p>• <strong>不回避限制：</strong>1039有明确的规则边界，企业应在规则范围内合规操作</p>
                <p>• <strong>不承诺灰色操作：</strong>任何变相退税、逃避监管的操作都是违规的</p>
                <p>• <strong>选择专业服务商：</strong>通过有经验的正规服务商操作，确保全程合规</p>
                <p>• <strong>保持透明操作：</strong>真实申报、配合监管、保留完整资料</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PolicyFAQ;